import React from "react";
import { positions as playerPositions } from "shared/utils/player.js";

const positionStyle = {
  GK: { top: "90%", left: "50%" },
  CB: { top: "75%", left: "50%" },
  LB: { top: "75%", left: "25%" },
  RB: { top: "75%", left: "75%" },
  LWB: { top: "64%", left: "15%" },
  RWB: { top: "64%", left: "85%" },
  CDM: { top: "60%", left: "50%" },
  CM: { top: "48%", left: "50%" },
  LM: { top: "48%", left: "25%" },
  RM: { top: "48%", left: "75%" },
  CAM: { top: "36%", left: "50%" },
  LW: { top: "18%", left: "20%" },
  RW: { top: "18%", left: "80%" },
  CF: { top: "21%", left: "50%" },
  ST: { top: "8%", left: "50%" },
};

interface ControllerPositionsProps {
  positions?: string[];
  onChange: func;
}

const ControllerPositions: React.FC<ControllerPositionsProps> = ({ positions, onChange }) => {
  const onClick = (p) => {
    let newSelectedPositions = positions;

    if (newSelectedPositions?.indexOf(p) >= 0) {
      newSelectedPositions = newSelectedPositions.filter((pos) => pos !== p);
    } else {
      newSelectedPositions = newSelectedPositions ? newSelectedPositions.concat([p]) : [p];
    }

    onChange(newSelectedPositions);
  };

  return (
    <div className="row">
      <div className="col-12 mb-1">
        <h4>Position</h4>
      </div>
      <div className="col-12">
        <div className="football-field position-relative w-100 h-100 ratio ratio-1x1">
          <div className="football-field-lines">
            <div className="halfway-line" />
            <div className="center-circle" />
            <div className="goal-box" />
          </div>

          {playerPositions.map((p) => (
              <button
                key={p.name}
                className={`btn btn-sm position-button position-absolute h-auto w-auto
                  ${positions && positions.includes(p.name) ? " primary-color-background text-white" : " text-white"}`}
                style={{...positionStyle[p.name], transform: "translate(-50%, -50%)"}}
                onClick={() => onClick(p.name)}
              >
                <span className="position-name">{p.name}</span>
              </button>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ControllerPositions;
